module.exports = __webpack_public_path__ + "img/book-1.7bbf2c57.png";